import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Skeleton, Chip } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { red, orange, amber, blue, purple, green, grey } from '@mui/material/colors';
import api from '../../../services/api';

const CAUSE_COLORS = {
    'Timeout':           red[600],
    'Sem rota':          orange[700],
    'DNS':               amber[700],
    'Conexão recusada':  purple[600],
    'Credencial':        red[800],
    'SSH':               blue[600],
    'Template/Comando':  purple[800],
    'Outras':            grey[500],
};

const PERIODS = [
    { value: 'today', label: 'Hoje' },
    { value: '7d',    label: '7 dias' },
    { value: '30d',   label: '30 dias' },
];

export default function CausesDonut() {
    const [period, setPeriod] = useState('today');
    const [data, setData] = useState({ total: 0, distribution: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/hermes/dashboard/causes_grouped?period=${period}`)
            .then(r => setData(r.data || { total: 0, distribution: [] }))
            .finally(() => setLoading(false));
    }, [period]);

    return (
        <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} flexWrap="wrap" gap={1}>
                <Typography variant="h6" sx={{ fontFamily: 'Montserrat', fontWeight: 500 }}>
                    Causas das falhas
                </Typography>
                <Box display="flex" gap={0.5}>
                    {PERIODS.map(p => (
                        <Chip key={p.value} label={p.label} size="small"
                              onClick={() => setPeriod(p.value)}
                              color={period === p.value ? 'primary' : 'default'}
                              variant={period === p.value ? 'filled' : 'outlined'} />
                    ))}
                </Box>
            </Box>

            {loading ? (
                <Skeleton variant="rectangular" height={260} />
            ) : data.total === 0 ? (
                <Box height={260} display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={1}>
                    <Typography variant="h6" color={green[600]}>Sem falhas no período</Typography>
                    <Typography variant="caption" color="text.secondary">tudo verde</Typography>
                </Box>
            ) : (
                <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
                    <Box flex="1 1 200px" minWidth={200}>
                        <ResponsiveContainer width="100%" height={240}>
                            <PieChart>
                                <Pie data={data.distribution} dataKey="count" nameKey="cause"
                                     innerRadius={55} outerRadius={90} paddingAngle={2}>
                                    {data.distribution.map((e, i) => (
                                        <Cell key={i} fill={CAUSE_COLORS[e.cause] || grey[400]} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(v, _, p) => [`${v} (${p.payload.pct}%)`, p.payload.cause]} />
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Box flex="1 1 200px" minWidth={200} display="flex" flexDirection="column" gap={0.75}>
                        {data.distribution.map((d, i) => (
                            <Box key={i} display="flex" alignItems="center" gap={1}>
                                <Box sx={{ width: 12, height: 12, borderRadius: 0.5,
                                           bgcolor: CAUSE_COLORS[d.cause] || grey[400], flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ flexGrow: 1 }}>{d.cause}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    <strong>{d.count}</strong> · {d.pct}%
                                </Typography>
                            </Box>
                        ))}
                        <Typography variant="caption" color="text.secondary" mt={0.5}>
                            Total: {data.total}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Paper>
    );
}
